// src/features/resources/ResourcesLayer.js
import React, { useState } from "react";
import { Container, Box, Fab } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ResourceList from "../components/resources/ResourceList";
import ResourceModal from "../components/resources/ResourceModal";
import { THEME_COLORS } from "../styles/theme";

const ResourcesLayer = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [editResourceId, setEditResourceId] = useState(null);

  const openCreate = () => {
    setEditResourceId(null);
    setModalOpen(true);
  };

  const openEdit = (resourceId) => {
    setEditResourceId(resourceId);
    setModalOpen(true);
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 8 }}>
      <ResourceList onEdit={openEdit} />

      <ResourceModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onSaved={() => {
          // If you want to refresh list, add a callback/emit event
          window.location.reload(); // simple for now; replace with better state handling if desired
        }}
        editResourceId={editResourceId}
      />

      <Box
        sx={{
          position: "fixed",
          bottom: 24,
          right: 24,
          zIndex: 1200
        }}
      >
        <Fab
          onClick={openCreate}
          sx={{ bgcolor: THEME_COLORS.primary, color: "white", "&:hover": { bgcolor: "#1e1c4e" } }}
        >
          <AddIcon />
        </Fab>
      </Box>
    </Container>
  );
};

export default ResourcesLayer;
